import React, { useEffect, useState } from "react";

import {
  MapContainer,
  TileLayer,
  Polyline,
  Marker,
  Popup,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import { API_BASE_PATH } from "../../constants/workerConstants";
import { connect } from "react-redux";
import L from "leaflet";
import { GoToBack } from "../../components/ui/GoToBack header/GoToBack";

// ✅ Fix for missing default marker icons
// import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Custom start (green) and end (red) icons
const startIcon = new L.Icon({
 // iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
  iconUrl: "https://cdn-icons-png.flaticon.com/128/668/668087.png",
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

const endIcon = new L.Icon({
  //iconUrl:"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
  iconUrl:"data:image/png;base64,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",
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

//  Helper component to auto-fit the map to trip bounds
function FitMapBounds({ coords }) {
  const map = useMap();
  useEffect(() => {
    if (coords.length > 0) {
      const bounds = L.latLngBounds(coords);
      map.fitBounds(bounds, { padding: [40, 40] });
    }
  }, [coords, map]);
  return null;
}

function Mapcomponent(props) {
  const [coords, setCoords] = useState([]);

  // ✅ Convert dates to ISO format
  const startsAfterISO = new Date(props.start.timestamp).toISOString();
  const endsBeforeISO = new Date(props.end.timestamp).toISOString();

  const getTripData = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_PATH}/bouncie/getTripData?ends-before=${endsBeforeISO}&gps-format=geojson&imei=${props.imei}&starts-after=${startsAfterISO}&transaction-id=${props.transactionId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: props.authToken,
          },
        }
      );

      if (res.data?.length > 0) {
        // GeoJSON stores [lng, lat], convert to [lat, lng]
        const points = res.data[0].gps.coordinates.map(([lng, lat]) => [
          lat,
          lng,
        ]);
        setCoords(points);
        props.setdata(res.data)
      }
    } catch (err) {
      console.error("Error fetching trip data:", err);
    }
  };

  useEffect(() => {
    getTripData();
  }, []);

  if (coords.length === 0) return <p className="text-center">Loading map...</p>;

  const start = coords[0];
  const end = coords[coords.length - 1];

  return (
    <>
    <MapContainer
      center={start}
      zoom={14}
      style={{
        height: "500px",
        width: "100%",
       // margin: "20px auto",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      }}
    >
      {/* Base map */}
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="© OpenStreetMap contributors"
      />

      {/* Polyline for the trip path */}
      <Polyline positions={coords} color="blue" weight={4} />

      {/* Start marker */}
      <Marker position={start} icon={startIcon}>
        <Popup>Trip Start</Popup>
      </Marker>

      {/* End marker */}
      <Marker position={end} icon={endIcon}>
        <Popup>Trip End</Popup>
      </Marker>

      {/* Auto-fit map to route */}
      <FitMapBounds coords={coords} />
    </MapContainer>

    </>
  );
}

const mapStateToProps = (state) => ({
  authToken: state.persist.authToken,
});

export default connect(mapStateToProps)(Mapcomponent);
